import { axios } from "../../utils";

export async function loginAPI(email, password) {
  const response = await axios.post("/login", {
    email,
    password,
  });
  return response.data;
}
